import React from "react";

const RadioGroup = ({ name, value, onChange, options, required }) => {
  return (
    <div className="radio-group">
      {options &&
        options.map((option) => (
          <label key={option.value} className="rad-label">
            <input
              className="rad-input"
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange(option.value)}
              required={required}
            />
            <div className="rad-design"></div>
            <span className="rad-text">{option.label}</span>
          </label>
        ))}
    </div>
  );
};

export default RadioGroup;
